import { Col } from '../../components/custom';

export default function DecliningEngagement()
{
    return (
        <Col id='decliningEngagement' className='perspectives'>
            <Col className='banner'>
                <span className='title'>Diagnosing What's Behind Declining Engagement</span>
                <span className='desc'>Go deeper than scores — discover the “why” behind disengagement.</span>
            </Col>
            <Col className='section'>
                <span className='title'>The Challenge</span>
                <span className='desc bold'>Engagement scores don't tell the whole story.</span>
                <span className='descsmall'>When scores start to slip, organizations are often left navigating a maze of potential causes: burnout, weak leadership, lack of growth, or change fatigue. Without clarity on the root drivers, most efforts to re-engage employees are reactive — and often ineffective.</span>
            </Col>
            <Col className='section'>
                <span className='title'>Our Philosophy</span>
                <span className='desc bold'>Measure what matters. Understand what's hidden. Act on what's true.</span>
                <span className='descsmall'>We believe the key to tackling disengagement lies in moving beyond dashboards to combine structured survey data with human sentiment, behavior signals, and organizational context. This empowers leaders with deep, directional insight — not just KPIs.</span>
            </Col>
            <Col className='section'>
                <span className='title'>The Diagnostic Framework</span>
                <span className='desc'>A modular approach that brings analytics and empathy together:</span>
                <ul>
                    <li className='descsmall'>
                        <strong>Signal Mapping</strong>
                        <ul>
                            <li className='descsmall'>Analyze engagement trends by function, level, and tenure.</li>
                            <li className='descsmall'>Identify where disengagement is showing up first — and who it's affecting most.</li>
                        </ul>
                    </li>
                    <li className='descsmall'>
                        <strong>Voice Intelligence</strong>
                        <ul>
                            <li className='descsmall'>Use NLP to mine open-ended feedback for recurring themes and tone.</li>
                            <li className='descsmall'>Capture nuanced signals like frustration, confusion, or lack of belonging.</li>
                        </ul>
                    </li>
                    <li className='descsmall'>
                        <strong>Contextual Layering</strong>
                        <ul>
                            <li className='descsmall'>Overlay internal events (e.g., restructures, leadership changes) and external pressures (e.g., market uncertainty).</li>
                            <li className='descsmall'>Map the “why now” behind the drop.</li>
                        </ul>
                    </li>
                    <li className='descsmall'>
                        <strong>Root Cause Validation</strong>
                        <ul>
                            <li className='descsmall'>Build hypotheses around burnout, poor recognition, or misaligned leadership.</li>
                            <li className='descsmall'>Validate these using correlation and segmentation analytics.</li>
                        </ul>
                    </li>
                </ul>
            </Col>
            <Col className='section'>
                <span className='title'>What This Enables</span>
                <ul>
                    <li className='descsmall'><strong>Precision over assumptions</strong> — No more generic engagement strategies.</li>
                    <li className='descsmall'><strong>Tailored action plans</strong> — Targeted interventions aligned to real issues.</li>
                    <li className='descsmall'><strong>Stronger leadership alignment</strong> — Equip leaders with clear narratives and next steps.</li>
                    <li className='descsmall'><strong>Better retention outcomes</strong> — Identify and act before dissatisfaction turns into attrition.</li>
                </ul>
            </Col>
            <Col className='section'>
                <span className='title'>The Takeaway</span>
                <span className='desc bold'>Disengagement isn't just a metric problem — it's a meaning problem.</span>
                <span className='descsmall'>With the right intelligence, organizations can decode disengagement early, act with clarity, and rebuild connection where it matters most.</span>
            </Col>
        </Col>
    )
}